import VideoStage from '../components/video-stage/video-stage';
import Columns from '../components/columns/columns';
import ModuleTitle from '../components/module-title/module-title';
import LocationDetails from '../components/location-details/location-details';
import LocationFlexible from '../components/location-flexible/location-flexible';
import Spacer from '../components/spacer/spacer';
import TextImageSlider from '../components/text-image-slider/text-image-slider';
import TestimonialsSlider from '../components/testimonials-slider/testimonials-slider';
import TextImage from '../components/text-image/text-image';
import ContactForm from '../components/contact-form/contact-form';
import ContactFormRoom from '../components/contact-form-room/contact-form-room';
import ContactFormRoomFlexible from '../components/contact-form-room-flexible/contact-form-room-flexible';
import TabNavigation from '../components/tab-navigation/tab-navigation';
import InteractiveMap from '../components/interactive-map/interactive-map';
import Faq from '../components/faq/faq';
import Gallery from '../components/gallery/gallery';

export default function RenderService(component) {
  switch (component.type) {
    case 'video-stage':
      return (
        <VideoStage
          key={`component-${component.id}`}
          data={component}
        ></VideoStage>
      );
    case 'columns':
      return (
        <Columns key={`component-${component.id}`} data={component}></Columns>
      );
    case 'module-title':
      return (
        <ModuleTitle
          key={`component-${component.id}`}
          data={component}
        ></ModuleTitle>
      );
    case 'text-image-slider':
      return (
        <TextImageSlider
          key={`component-${component.id}`}
          data={component}
        ></TextImageSlider>
      );
    case 'testimonials-slider':
      return (
        <TestimonialsSlider
          key={`component-${component.id}`}
          data={component}
        ></TestimonialsSlider>
      );
    case 'text-image':
      return (
        <TextImage
          key={`component-${component.id}`}
          data={component}
        ></TextImage>
      );
    case 'contact-form':
      return (
        <ContactForm
          key={`component-${component.id}`}
          data={component}
        ></ContactForm>
      );
    case 'contact-form-room':
      return (
        <ContactFormRoom
          key={`component-${component.id}`}
          data={component}
        ></ContactFormRoom>
      );
    case 'contact-form-room-flexible':
      return (
        <ContactFormRoomFlexible
          key={`component-${component.id}`}
          data={component}
        ></ContactFormRoomFlexible>
      );
    case 'tab-navigation':
      return (
        <TabNavigation
          key={`component-${component.id}`}
          data={component}
        ></TabNavigation>
      );
    case 'interactive-map':
      return (
        <InteractiveMap
          key={`component-${component.id}`}
          data={component}
        ></InteractiveMap>
      );
    case 'location-details':
      return (
        <LocationDetails
          key={`component-${component.id}`}
          data={component}
        ></LocationDetails>
      );
    case 'location-flexible':
      return (
        <LocationFlexible
          key={`component-${component.id}`}
          data={component}
        ></LocationFlexible>
      );
    case 'spacer':
      return (
        <Spacer
          key={`component-${component.id}`}
          data={component}
        ></Spacer>
      );
    case 'faq':
      return <Faq key={`component-${component.id}`} data={component}></Faq>;
    case 'gallery':
      return (
        <Gallery key={`component-${component.id}`} data={component}></Gallery>
      );
    default:
      return <div key={`component-${component.id}`}>{component.type}</div>;
  }
}
